<template>
  <section class="agenda tuesday">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Wednesday, April 30th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>11:00 AM</p>
              </div>
            </div>
            <br class="line-brk">
            <div v-for="(speaker, index) in morningSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
            <div class="cards__single grayblue">
              <p class="cards__title">
                VIP Lunch
              </p>
              <div class="cards__description">
                <p>1:00 PM - 2:30 PM</p>
              </div>
            </div>
            <div class="cards__single cryptoknights">
              <p class="cards__title">
                <a href="https://www.cryptoknights.tv/" target="_blank">
                  <img src="@/assets/logos/cryptoknights.png" alt="Crypto Knights Logo" class="ck">
                </a>
              </p>
              <div class="cards__description">
                <p>1:15 PM - 2:15 PM</p>
              </div>
            </div>
            <div v-for="(speaker, index) in afternoonSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>6:00 PM - 7:30 PM</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                Whale Supper Club
              </p>
              <div class="cards__description">
                <p>7:30 PM - 9:30 PM</p>
              </div>
            </div>
            <div class="cards__single party">
              <p class="cards__title">
                Legends Never Die Party
              </p>
              <div class="cards__description">
                <p>10:00 PM - 1:00 AM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      morningSet: [
        { 
          logoClass: 'zkalyx',
          name: 'Zkalyx',
          title: 'Robert Hirsch, CEO',
          time: '12:00 PM - 12:10 PM',
          class: 'logo'
        },
        {
          logoClass: 'monoquant',
          name: 'Monoquant',
          title: 'Ryan DiRocco, Board Advisor',
          time: '12:10 PM - 12:20 PM',
          class: 'logo'
        },
        {
          logoClass: 'inbestgo',
          name: 'Inbestgo',
          title: 'David Aw, CEO',
          time: '12:20 PM - 12:30 PM',
          class: 'logo'
        },
        {
          logoClass: 'libera-logo',
          name: 'Libera',
          title: 'Max Ward, Founder & CEO',
          time: '12:30 PM - 12:40 PM',
          class: 'logo'
        },
        {
          logoClass: 'matterfi',
          name: 'MatterFi / American Fortress',
          title: 'Michal “Mehow” Pospieszalski, CEO & Co-Founder',
          time: '12:40 PM - 12:50 PM',
          class: 'logo'
        },
        {
          logoClass: 'bos',
          name: 'BitcoinOS',
          title: 'Calvin Ferreira, Head of Ecosystem',
          time: '12:50 PM - 1:00 PM',
          class: 'logo'
        },
      ],
      afternoonSet: [
        {
          name: 'The Future of Peak Performance - Merging Tech, Finance & Biology',
          title: 'Panel Moderator: Terence Qwok, Humanity Protocol<br>Victor Debbas, MESLO<br>Aldo De Pape, Genomes<br>James Brown, Muhdo',
          time: '2:30 PM - 3:00 PM',
          class: 'noheight panel'
        },
        {
          imgClass: 'a-s',
          name: 'Fireside Chat: Navigating the Financial Future - Crypto, Chaos, and the Rise of the New Monetary Order',
          title: 'Arthur Hayes, BitMEX / Maelstrom<br>Scott Melker, The Wolf of All Streets',
          time: '3:00 PM - 3:30 PM',
          class: 'noheight special'
        },
        {
          name: 'New Token Launches for 2025 and Beyond: DNA & Coinlist',
          title: 'Panel Moderator: Scott Walker, DNA<br>Scott Keto, Coinlist<br> Raghav Gulati, Coinlist',
          time: '3:30 PM - 4:00 PM',
          class: 'noheight panel'
        },
        {
          name: 'The Opportunities and Risks of RWA Tokenization',
          title: 'Panel Moderator: Terence Qwok, Humanity Protocol<br>Jeremy Ng, OpenEden Group<br>Raj Brahmbhatt, Zeebu<br>Reeve Collins, Tether<br>J.D. Seraphine, Raiinmaker',
          time: '4:00 PM - 4:30 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'mbg',
          name: 'MultiBank Group: MBG Ecosystem',
          title: 'Zak Tahar, CEO<br>Courtney Fitzsimmons, CCO<br>Marc Aspinall, CCO',
          time: '4:30 PM - 4:45 PM',
          class: 'noheight panel nobg'
        },
        { 
          logoClass: 'chintai-dna',
          name: 'Chintai',
          title: 'David Packham, CEO & Founder',
          time: '4:45 PM - 5:00 PM',
          class: 'logo'
        },
        {
          logoClass: 'dna',
          name: 'DNA Market Making',
          title: 'Keir Formin, DNA',
          time: '5:00 PM - 5:20 PM',
          class: 'logo'
        },
        {
          imgClass: 'c-a',
          name: 'The Future of Family Offices & Frontier Finance',
          title: 'Chris Miglino, DNA<br>Adam Ladjadj, Emirates Family Office',
          time: '5:20 PM - 6:00 PM',
          class: 'noheight special'
        }
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
